
import Vue from 'vue';
import DocumentResultController from '@/controllers/DocumentResultController';
import deepEqual from '@/util/deep-equals';
import { IngestDescriptor } from '@/model';

export interface Goto {
  documentId: number;
  ingestId?: number;
  fragmentId?: number;
}

export default Vue.extend({
  name: 'DocumentPopover',
  components: { DocumentResultController },

  props: {
    goto: { type: Object as () => Goto | undefined, required: true },
    backText: { type: String, default: 'Back' },
  },

  watch: {
    goto: {
      immediate: true,
      handler(to: Goto | undefined, from) {
        if (!deepEqual(to, from)) {
          this.scrollTop = window.scrollY;
          this.documentId = to?.documentId;
          this.ingestId = to?.ingestId;
          this.fragmentId = to?.fragmentId;
        }
      },
    },
  },

  data() {
    return {
      scrollTop: undefined as undefined | number,
      documentId: undefined as undefined | number,
      ingestId: undefined as undefined | number,
      fragmentId: undefined as undefined | number,
    };
  },

  methods: {
    changeIngestion(descriptor: IngestDescriptor) {
      this.ingestId = descriptor.ingestId;
    },
    close() {
      if (this.scrollTop !== undefined) {
        this.$nextTick(() => {
          window.scrollTo(0, this.scrollTop || 0);
        });
      }
      this.$emit('closeDocument');
    },
  },
});
